import { createContext, useContext, useEffect, useState } from "react";
import ApiServices from "../../../service/ApiServices";


const SettingsContext = createContext();

const res = new ApiServices();

export const SettingsProvider = ({children}) => {

    const [settings, setSettings] = useState([]);


    useEffect(() => {
            res.getSettings().then(setSettings);
    }, []);

    const hasPayments = () => {
        if (settings?.payment && settings?.payment !== 'undefined') {
            return Object.values(settings?.payment).some(item => item.status !== '0');
        }
        return false
    }

    const schedule = () => {
        if (settings?.schedule) {

            const schedule = JSON.parse(settings?.schedule)
            return [
                {'понеділок': {
                    start: schedule.mn_from,
                    end:  schedule.mn_to,
                }},
                {'вівторок': {
                   start: schedule.tu_from,
                    end:  schedule.tu_to,
                }},
                {'середа': {
                    start: schedule.ve_from,
                    end:  schedule.ve_to,
                }},
                {'четвер': {
                    start: schedule.th_from,
                    end:  schedule.th_to,
                }},
                {"п’ятниця": {
                    start: schedule.fr_from,
                    end:  schedule.fr_to,
                }},
                {"субота": {
                    start:  schedule.sa_from,
                    end:   schedule.sa_to,
                }},
                {"неділя": {
                    start:  schedule.su_from,
                    end:   schedule.su_to,
                }},
            ];        
        }

        return []
    }

    return (
        <SettingsContext.Provider
            value={{
                settings,
                hasPayments, schedule
            }}
        >
            {children}
        </SettingsContext.Provider>
    )
}

export const useSettings = () => {
    return useContext(SettingsContext);
}